export const filterTarihselFiyatByPeriod = (tarihselFiyatBilgileri, period) => {
  if (!tarihselFiyatBilgileri || !tarihselFiyatBilgileri.length) return [];

  let count;

  switch (period) {
    case "Haftalık":
      count = 6;
      break;
    case "Aylık":
      count = 22;
      break;
    case "3 Aylık":
      count = 66;
      break;
    case "1 Yıllık":
      count = 250;
      break;
    case "2 Yıllık":
      count = 250 * 2;
      break;
    case "5 Yıllık":
      count = 250 * 5;
      break;
    default:
      return tarihselFiyatBilgileri;
  }

  return tarihselFiyatBilgileri.slice(-count);
};
